import React, { useContext } from "react";
import { MyContext } from "../../Context/MyContext";
import classes from "./ThemeToggle.module.css";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useContext(MyContext);
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className={`${classes.toggle} ${isDark ? classes.dark : ""}`}
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      <span className={classes.track}>
        <span className={classes.icon} aria-hidden="true">
          <svg viewBox="0 0 24 24" className={classes.sun}>
            <circle cx="12" cy="12" r="4" fill="currentColor" />
            <path
              d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
          <svg viewBox="0 0 24 24" className={classes.moon}>
            <path
              d="M20 14.5A8.2 8.2 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5Z"
              fill="currentColor"
            />
          </svg>
        </span>
      </span>
    </button>
  );
}
